
export default function FigCaption({Figure, caption}:{Figure:any, caption:string}) {
    return (
        <div
            className="figcaption"
        >
            <figure
                className="h-8 w-8 mb-1"
                role="figure"
            >
                {/* <SvgIcon 
                    component={figure}
                    viewBox="0 0 34.378 54.281"
                    fontSize="large"
                /> */}
                <Figure />
            </figure>
            <span
                className="caption text-md sm:text-sm"
            >
                {caption}
            </span>
            
        </div>
    )
}
